/* eslint-disable react/require-default-props */
import {
  AppContext,
  getTranslatedText,
  reactSelectInlineError,
  isAuthorised
} from '@nile/components';
import { ToggleButton } from '@superops/ui-design-system';
import { includes, omit } from 'lodash';
import React, { useContext } from 'react';
import { FormattedMessage, useIntl, IntlShape } from 'react-intl';
import { ServiceCatalogFormContext } from './ServiceCatalogForm/index';
import TaxSelector from './TaxSelector';

interface TaxConfigurationProps {
  taxable?: boolean;
  salesTax?: {
    taxId: string;
  };
  disabledSections?: string[];
  handlePropChange: (key: string, value: any) => void;
  handlePropertiesChange: (object: any) => void;
  properties?: { taxable: string; salesTax: string };
  label?: {
    taxable: string;
    salesTax: string;
  };
  negate?: boolean;
}

function TaxConfiguration(props: TaxConfigurationProps): React.ReactElement {
  const {
    taxable,
    salesTax,
    disabledSections,
    handlePropChange,
    handlePropertiesChange,
    properties = { taxable: 'taxable', salesTax: 'salesTax' },
    label = {
      taxable: 'admin.serviceCatalog.taxConfiguration.salesTaxEnabled',
      salesTax: 'admin.serviceCatalog.taxConfiguration.salesTax'
    },
    negate
  } = props;
  const intl: IntlShape = useIntl();
  const { user } = useContext<any>(AppContext);
  const { errors } = useContext(ServiceCatalogFormContext);
  const reference = user?.role?.roleFeatureList || [];
  const clientLocation = user?.site?.countryCode || false;
  const isTaxForIndividualItemsNotAllowed = false;

  const showTaxRegion = negate ? !taxable : taxable;

  return (
    <div className="fx actr min-height-42">
      <div className="fx actr">
        <ToggleButton
          value={taxable}
          onChange={(checked) => {
            if (checked) {
              handlePropChange(properties.taxable, checked);
            } else {
              handlePropertiesChange({
                [properties.taxable]: checked,
                [properties.salesTax]: null
              });
            }
          }}
          locked={includes(disabledSections, 'taxable')}
          size="small"
        />
        <span className="ml8">
          <FormattedMessage id={label.taxable} />
        </span>
      </div>
      {!isTaxForIndividualItemsNotAllowed &&
        showTaxRegion &&
        isAuthorised(reference, 'tax.view') && (
          <div className="flex center ml-40 fg1 maxW350">
            <div className="mr-10">
              <FormattedMessage id={label.salesTax} />
            </div>
            <TaxSelector
              salesTax={salesTax}
              isDisabled={includes(disabledSections, 'salesTax')}
              onChange={(selectedTaxRate) => {
                const salesTaxValue = {
                  ...omit(selectedTaxRate, [
                    'label',
                    'value',
                    'id',
                    'rates',
                    'integrated',
                    'name'
                  ])
                };
                handlePropChange(properties.salesTax, salesTaxValue);
              }}
            />
            {errors?.['salesTax.taxId']?.[0] &&
              reactSelectInlineError(
                getTranslatedText(intl, 'Choose a tax from the options')
              )}
          </div>
        )}
    </div>
  );
}

export default TaxConfiguration;
